<h2 class="mt-3 mb-4">Delete User Account</h2>
<div class="notice notice-error" *ngIf="error">
  <div class="notice-body">Failed to delete user account: {{ error?.description }}</div>
</div>
<div class="notice notice-error" *ngIf="promptConfirm">
  <div class="notice-body">Are you sure you want to delete your portal account? This action is irreversible and removes history and contract
    access permanently.</div>
</div>

<div class="material-form-grid">
  <mat-form-field appearance="fill">
    <mat-label>Email</mat-label>
    <input matInput id="email" [(ngModel)]="email" name="email" />
  </mat-form-field>

  <app-all-seeing-eye label="Account Password" [(ngModel)]="password" hintText="Required for authorisation"></app-all-seeing-eye>

  <div class="form-actions full-width">
    <button mat-flat-button color="warn" id="delete-account-button" type="button" *ngIf="!promptConfirm" (click)="deleteUser()"
      [disabled]="deleteDisabled()">
      Delete Account
    </button>
    <button mat-flat-button color="warn" id="confirm-delete-account-button" type="button" *ngIf="promptConfirm" (click)="deleteUser(true)"
      [disabled]="deleteDisabled()">
      <mat-spinner *ngIf="deleting" diameter="20" mode="indeterminate"></mat-spinner>
      {{ deleting ? 'Deleting' : 'Confirm Delete' }}
    </button>
  </div>
</div>
